module.exports = __webpack_public_path__ + "static/media/print-logo-8.ed8576b9.png";